module.exports = __webpack_public_path__ + "img/fitted-mask-elastic-default.3b4b035e.jpg";